module.exports = __webpack_public_path__ + "img/ethereum-symbol.95503cfc.png";